export const fadeIn = [
  { offset: 0, opacity: '0' },
  { offset: 1, opacity: '1' }
];
